
import Vue from "vue";
import Component from "vue-class-component";
import { getAuthorization } from "@/api/common";
import {
  formatDate,
  guid,
  getFileExtendingName,
  getYearMonthNow,
  getDateNow
} from "@/api/tools"; //导入相关工具
import { MarketReportApi } from "@/api/marketReportApi"; //导入配套接口API
import { GroceryMarketShareApi } from "@/api/groceryMarketShareApi";
import {
  GetStsParam,
  UploadClass
} from "@/models/marketReport/marketReportData"; //导入配套数据定义Model
import OSS from "ali-oss";

@Component({}) // Component装饰器装饰类
export default class MarketReport extends Vue {
  // --------------------------------------------------------------数据区-------------------------------------------------------------
  stsParam: GetStsParam = new GetStsParam();
  ossClient: UploadClass = new UploadClass();
  // 获取接口API
  marketReport: MarketReportApi = new MarketReportApi();
  groceryMarketShare: GroceryMarketShareApi = new GroceryMarketShareApi();
  // authObj: Auth = new Auth();
  name = "MarketReport";
  // 上传身份认证
  file = {};
  uploadList = [];
  headersParams = {
    authorization: null
  };
  // 上传Excel地址
  uploadExcelUrl = "";
  uploadPdfUrl = "";
  // 上传Excel参数
  uploadExcelParam = {
    description: ""
  };
  // stepActive = 1;
  $refs: Vue["$refs"] & {
    uploadExcel: any;
    uploadPDF: any;
  };
  client: any = null;
  expire: any = null;
  timestamp: any = null;
  percentage: number = 0;
  pdfLoading: boolean = false;
  excelLoading: boolean = false;

  created() {
    this.headersParams.authorization = getAuthorization();
    this.uploadExcelUrl = this.groceryMarketShare.uploadExcelUrl;
    this.uploadPdfUrl = this.groceryMarketShare.uploadPdfUrl;
  }
  // Excel上传
  onUploadExcel() {
    if (this.$refs.uploadExcel.uploadFiles.length === 0) {
      this.$message.warning("请先选择EXCEL文件");
    } else {
      this.$refs.uploadExcel.submit();
    }
  }

  // PDF上传
  onUploadPDF() {
    if (this.$refs.uploadPDF.uploadFiles.length === 0) {
      this.$message.warning("请先选择PDF文件");
    } else {
      this.$refs.uploadPDF.submit();
    }
  }
  // // 上传pdf
  // submitUpload() {
  //   this.pdfLoading = true
  //   let vm = this;
  //   return vm
  //     .setUploadParam()
  //     .then(async status => {
  //       if (status === 200) {
  //         this.multipartUpload(this.file);
  //       }
  //     })
  //     .catch(error => {
  //       this.$message.error("文件上传失败，请重试");
  //     });
  // }
  // // 开始上传
  // async multipartUpload(param) {
  //   let vm = this;
  //   let ossClient = JSON.parse(sessionStorage.getItem("ossClient"));
  //   const storeAs =
  //     new Date().getFullYear() +
  //     "/" +
  //     getYearMonthNow() +
  //     "/" +
  //     getDateNow() +
  //     "/" +
  //     guid() +
  //     getFileExtendingName(param.name);
  //   vm.client = new OSS(ossClient);
  //   await vm.client
  //     .multipartUpload(storeAs, param, {
  //       progress: async function(percentage, cpt) {
  //         vm.percentage = parseInt(percentage * 100);
  //       }
  //     })
  //     .then(async result => {
  //       console.log("result------------", result);
  //       this.uploadExcelParam.pdfPath = result.name;
  //       vm.addFile(vm.uploadExcelParam);
  //       this.pdfLoading = false
  //     })
  //     .catch(err => {
  //       if (!vm.client.isCancel()) {
  //         this.pdfLoading = false
  //         this.$message.warning("上传失败");
  //       }
  //     });
  // }
  // addFile(file: any) {
  //   this.marketReport.savePdfPath(file).then((res: any) => {
  //     this.$message.success("上传成功");
  //   });
  // }
  // // 文件上传之前判断签名是否过期
  // setUploadParam() {
  //   return new Promise((resolve, reject) => {
  //     let now = (this.timestamp = new Date().getTime());
  //     this.expire = Number(sessionStorage.getItem("expire"));
  //     if (this.expire < now + 3) {
  //       this.marketReport.getStsToken(this.stsParam).then(
  //         (res: any) => {
  //           this.ossClient.accessKeyId = res.data.accessKeyId;
  //           this.ossClient.accessKeySecret = res.data.accessKeySecret;
  //           this.ossClient.stsToken = res.data.securityToken;
  //           this.expire = new Date(res.data.expiration).getTime();
  //           sessionStorage.setItem("expire", String(this.expire));
  //           sessionStorage.setItem("ossClient", JSON.stringify(this.ossClient));
  //           resolve(200);
  //         },
  //         () => {
  //           reject(400);
  //         }
  //       );
  //     } else {
  //       resolve(200);
  //     }
  //   });
  // }
  // PDF上传前验证
  onBeforeUploadPDF(file) {
    this.pdfLoading = true;
    this.file = file;
  }
  onBeforeUploadExcel(file) {
    this.excelLoading = true;
  }
  onExceed(files, fileList) {
    this.$message.warning("当前限制选择 1 个文件，请先删除已选择的文件");
  }
  // 上传错误处理
  OnUploadError(err, file, fileList) {
    this.excelLoading = false;
    this.pdfLoading = false;
    var data = JSON.parse(err.message);
    if (data != null) this.$message.warning(data.message);
  }
  // Excel上传成功处理
  OnUploadSuccessExcel(response, file, fileList) {
    this.excelLoading = false;
    this.$message.success("上传成功");
  }
  // Pdf上传成功处理
  OnUploadSuccessPdf() {
    this.pdfLoading = false;
    this.$message.success("上传成功");
  }
}
